const AudioCtx = typeof window !== "undefined" ? (window.AudioContext || (window as any).webkitAudioContext) : null;

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (!AudioCtx) return null;
  if (!ctx) {
    try {
      ctx = new AudioCtx();
    } catch {
      return null;
    }
  }
  return ctx;
}

function playTone(freq: number, duration: number, volume: number, type: OscillatorType = "sine") {
  const c = getCtx();
  if (!c) return;
  try {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, c.currentTime);
    gain.gain.setValueAtTime(0, c.currentTime);
    gain.gain.linearRampToValueAtTime(volume, c.currentTime + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + duration);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start(c.currentTime);
    osc.stop(c.currentTime + duration);
  } catch {}
}

export function playClick() {
  playTone(800, 0.06, 0.03, "sine");
}

export function playSuccess() {
  const c = getCtx();
  if (!c) return;
  setTimeout(() => playTone(523, 0.12, 0.025, "sine"), 0);
  setTimeout(() => playTone(659, 0.12, 0.025, "sine"), 60);
  setTimeout(() => playTone(784, 0.15, 0.03, "sine"), 120);
}

export function playError() {
  playTone(220, 0.15, 0.03, "triangle");
}

export function playToggle(on: boolean) {
  playTone(on ? 660 : 440, 0.06, 0.025, "sine");
}

export function playNavigate() {
  playTone(600, 0.05, 0.02, "sine");
}
